/**
 * =============================================================================
 * newsletter-popup.js 
 * =============================================================================
 * Simple newsletter popup
 * =============================================================================
 */
var NewsletterPopup = {
  data: {
    selectors: {
      modal: ".modal-newsletter",
      reject_button: "[data-newsletter-popup-reject]"
    },

    expiry: {
      rejected: 30,
      count: 7,
      submitted: 365
    }
  },

  onReady: function(){
    // Establish whether we can / should show the popup
    var modals = document.querySelectorAll(this.data.selectors.modal);
    //console.log('[N-P]', modals); 
    var that = this;

    modals.forEach(function(modal) {
      // Set form completion event listener
      var form = modal.querySelector("form");
      var modalBlockId = modal.dataset.blockId;
      var triggerCount = modal.dataset.triggerCount;
      var delay = modal.dataset.delay;
      var formListener = function(e){
        e.preventDefault();
        form.removeEventListener("submit", formListener);
        Cookies.set('np-submitted-' + modalBlockId, true, { expires: that.data.expiry.submitted });
        form.submit();
      }.bind(that);
      form.addEventListener("submit", formListener);

      // Set reject event listener
      modal.querySelector(that.data.selectors.reject_button).addEventListener("click", that.onReject.bind(that, modalBlockId));

      // Update and trigger if over view count
      that.updateCount(modalBlockId);

      var modal = "modal-newsletter-" + modalBlockId;

      if(that.shouldShow(modalBlockId, triggerCount)) {
        setTimeout(function(){
          var modalDisplay = new bootstrap.Modal(document.getElementById(modal), {keyboard: false});
          modalDisplay.show();
          Cookies.set('np-shown-' + modalBlockId, true);
        }.bind(that), parseInt(parseFloat(delay) * 1000));
      }
    });
  },

  /**
   * Determine whether to show the popup
   * 
   * @returns {Boolean}
   */
  shouldShow(modalBlockId, triggerCount) {
    return this.getCount(modalBlockId) >= triggerCount && 
      !this.hasRejected(modalBlockId) &&
      !this.hasShown(modalBlockId) &&
      !this.hasBeenSubmitted(modalBlockId)
  },

  /**
   * Update the view count
   */
  updateCount(modalBlockId) {
    if(Cookies.get('np-count-' + modalBlockId) == undefined){
      Cookies.set('np-count-' + modalBlockId, 1, { expires: this.data.expiry.count });
    } else {
      Cookies.set('np-count-' + modalBlockId, parseInt(Cookies.get('np-count-' + modalBlockId)) + 1, { expires: this.data.expiry.count });
    }
  },

  /**
   * Get the view count
   * 
   * @returns {Integer}
   */
  getCount(modalBlockId) {
    return parseInt(Cookies.get('np-count-' + modalBlockId));
  },

  /**
   * Set a cookie to mark the prompt as rejected.
   */
  onReject(modalBlockId) {
    Cookies.set('np-rejected-' + modalBlockId, true, { expires: this.data.expiry.rejected });
  },

  /**
   * Get whether the prompt has previously been rejected
   * 
   * @returns {Boolean} whether the prompt has been rejected
   */
  hasRejected(modalBlockId) {
    return Cookies.get('np-rejected-' + modalBlockId) !== undefined;
  },

  /**
   * Get whether the prompt has previously been shown
   * 
   * @returns {Boolean} whether the prompt has been shown
   */
  hasShown(modalBlockId) {
    return Cookies.get('np-shown-' + modalBlockId) !== undefined;
  },

  /**
   * Get whether the prompt form has previously been submitted
   * 
   * @returns {Boolean} whether the prompt form has been submitted
   */
  hasBeenSubmitted(modalBlockId) {
    return Cookies.get('np-submitted-' + modalBlockId) !== undefined;
  }
};

module.exports = NewsletterPopup; 